import React from "react";

// reactstrap components
import { Container } from "reactstrap";

// core components

const IndexHeader = ({...props}) => {
  return (
    <>
      <div
        className="page-header section-dark"
        style={{
          backgroundImage:
            `url(${props.imageUrl})`,
            minHeight: parseInt(props.minHeight)
        }}
      >
        <div className="filter" />
        <div className="content-center">
          <Container>
            <div className="title-brand">
              <h1 className="presentation-title" style={{fontSize:70}}>{props.title}</h1>
              <div className="fog-low">
                <img alt="..." src={require("assets/img/fog-low.png")} />
              </div>
              <div className="fog-low right">
                <img alt="..." src={require("assets/img/fog-low.png")} />
              </div>
            </div>
            <h2 className="presentation-subtitle text-center">
              Hiện Đại - Sang Trọng - Tinh Tế
            </h2>
          </Container>
        </div>
        <div
          className="moving-clouds"
          style={{
            backgroundImage: "url(" + require("assets/img/clouds.png") + ")",
          }}
        />        
      </div>
    </>
  );
}

export default IndexHeader;
